module.exports = __webpack_public_path__ + "img/worksbot_img19121106.40c1ced7.jpg";